import { useRef, useState } from "react";
import { AiFillPlusSquare, AiFillMinusSquare } from "react-icons/ai";
import { FaWindowClose } from "react-icons/fa";
import { TbDragDrop } from "react-icons/tb";
import { downloadImage, generateCompoundImage, generateFigureImage, generateImage } from "utils/imageGenerator";

const ImageGenerateFloat = ({
  setImageFloatSideBar
}) => {
  const [markNameArr, setMarkNameArr] = useState([""]
  );
  const [, setOriginalFileName] = useState("");

  const [, setUploadComplete] = useState(false);
  const [, setFileName] = useState("");
  const [, setImagePath] = useState("");
  const [, setFile] = useState("");
  const [markType] = useState("");

  const [, setUploadImg] = useState("");
  const [dragState, setDragState] = useState("leave");
  const [selectedMarkType, setSelectedMarkType] = useState(markType || 'TEXT');

  const [tempImg, setTempImg] = useState(null)

  const markTypeOptions = [
    { value: 'TEXT', label: '문자상표' },
    { value: 'FIGURE', label: '도형상표' },
    { value: 'COMPOUND', label: '복합상표' }
  ];

  const hidePlusBtn = () => {
    if (selectedMarkType === "COMPOUND") {
      return markNameArr.length >= 2;
    }
    return markNameArr.length >= 5;
  };

  const fileInputRef = useRef(null)

  const [generatedImage, setGeneratedImage] = useState("");
  const [, setCompoundImageFilename] = useState("");
  const [, setCompoundImagePath] = useState("");

  const [, setUploadedImage] = useState(null);

  const imgPreview = (file) => {
    if (!file) return;

    setUploadedImage(file);

    const reader = new FileReader();
    reader.onload = (event) => {
      const result = event.target?.result;
      if (result) {
        setTempImg(result);
      }
    };
    reader.readAsDataURL(file);
    setUploadImg("uploaded");
  };

  const handleGenerate = async () => {
    try {
      if (selectedMarkType === "COMPOUND") {
        const dataUrl = await generateCompoundImage(
          tempImg,
          markNameArr,
          setCompoundImageFilename,
          setCompoundImagePath
        );
        setGeneratedImage(dataUrl);
      } else if (selectedMarkType === "TEXT") {
        const dataUrl = generateImage(
          markNameArr,
          setFileName,
          setImagePath
        );
        setGeneratedImage(dataUrl);
      } else if (selectedMarkType === "FIGURE") {
        const dataUrl = await generateFigureImage(
          tempImg,
          setFileName,
          setImagePath
        );
        setGeneratedImage(dataUrl);
      }
    } catch (err) {
      alert("이미지 생성에 실패했습니다.");
      console.error(err);
    }
  };



  const renderMarkNameInputs = () => {
    return markNameArr.map((markName, idx) => (
      <div className="row" key={idx}>
        <span>{idx + 1}단</span>
        <input
          className="modal-mark-name-edit-input"
          type="text"
          maxLength={19}
          value={markName}
          onChange={(e) =>
            setMarkNameArr((prev) => {
              const clone = [...prev];
              clone[idx] = e.target.value;
              return clone;
            })
          }
        />
        {idx === 0 ? (
          <AiFillPlusSquare
            style={{ width: "40px", height: "40px" }}
            className={hidePlusBtn() ? "btn-display-none" : ""}
            onClick={() =>
              setMarkNameArr((prev) => {
                const clone = [...prev];
                clone.push("");
                return clone;
              })
            }
          />
        ) : (
          <AiFillMinusSquare
            style={{ width: "40px", height: "40px" }}
            onClick={() =>
              setMarkNameArr((prev) => {
                const clone = [...prev];
                clone.splice(idx, 1);
                return clone;
              })
            }
          />
        )}
      </div>
    ));
  };



  return (
    <>
      <div className="modal-image">
        <div
          className="modal-inquiry-container"
          style={{ width: "400px", minHeight: "330px", height: 'auto' }}
        >
          <div className="modal-inquiry_header">
            <h3>상표 이미지 제작</h3>
            <div className="mark-type-selector">
              <select
                value={selectedMarkType}
                onChange={(e) => {
                  const newType = e.target.value;
                  setSelectedMarkType(newType);
                  setMarkNameArr([""]);
                  setUploadImg("");
                  setOriginalFileName("");
                  setFileName("");
                  setImagePath("");
                  setFile(null);
                  setTempImg("");
                  setUploadComplete(false);
                }}
              >
                {markTypeOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>

            </div>
            <div
              className="modal-inquiry-close"
              onClick={() => setImageFloatSideBar()}
            >
              <FaWindowClose />
            </div>
          </div>

          <div className="modal-mark-name-edit"
          >
            {selectedMarkType === "TEXT" && (
              <>
                <div className="modal-mark-name-edit-inputs">
                  {renderMarkNameInputs()}
                </div>
              </>
            )}
            {selectedMarkType !== "TEXT" && (
              <>
                <div className="header">
                  {selectedMarkType === "COMPOUND" && (
                    <>
                      <span>복합 상표는</span>
                      <span>최대 2단까지 입력 가능합니다.</span>
                    </>
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid #888888",
                    borderRadius: "10px",
                    height: "60%",
                    width: "80%",
                    marginBottom: "10px",
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    id="fileInputImageGenerate"
                    style={{ display: 'none' }}
                    ref={fileInputRef}
                    onClick={(e) => {
                      e.target.value = "";
                    }}
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (file) {
                        imgPreview(file);
                      }
                    }}
                  />

                  {tempImg ? (
                    <label className="imageInput" htmlFor="fileInputImageGenerate">
                      <img
                        style={{
                          maxHeight: '230px',
                          maxWidth: '300px'
                        }}
                        src={tempImg}
                        alt="업로드된 이미지"
                      />
                    </label>
                  ) : (
                    <label
                      htmlFor="fileInputImageGenerate"
                      style={{ cursor: 'pointer' }}
                      className={`imageInput column ${dragState}`}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const files = e.dataTransfer?.files;
                        if (!files || files.length === 0) return;

                        if (files.length > 1) {
                          alert('한 장만 올려주세요');
                          return;
                        }

                        const file = files[0];
                        if (fileInputRef.current) {
                          fileInputRef.current.value = "";
                        }

                        imgPreview(file);
                      }}
                      onDragEnter={() => setDragState("enter")}
                      onDragLeave={() => setDragState("leave")}
                    >
                      <TbDragDrop />
                      <span>이미지를 업로드해 주세요.</span>
                    </label>
                  )}
                </div>
              </>
            )}

            {selectedMarkType === "COMPOUND" && (
              <div className="modal-mark-name-edit-inputs">
                {renderMarkNameInputs()}
              </div>
            )}
          </div>
          <div className="modal-mark-name-edit-btn-group">
            <button onClick={handleGenerate}>생성</button>
            <button onClick={() => setImageFloatSideBar()}>
              취소
            </button>
          </div>
        </div>
        {generatedImage && (
          <div className="preview-area">
            <h4>미리보기</h4>
            <img src={generatedImage} alt="상표 이미지 미리보기" style={{ width: "100%", maxWidth: "200px" }} />
            <button onClick={() => downloadImage(generatedImage, "mark.jpg")}>
              다운로드
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default ImageGenerateFloat;
